import { InFilterDefinition } from '@factorialco/f0-react'
import {
  ImputableProjectFilterDocument,
  ImputableProjectFilterQuery,
} from 'generated/resources/graphql'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import i18n from 'modules/core/lib/i18n'

const extractConnection = (data: ImputableProjectFilterQuery) =>
  data.projectManagement.imputableProjectsConnection

const extractNodes = (connection: ReturnType<typeof extractConnection>) =>
  connection.edges.map((edge) => edge.node)

type Node = ReturnType<typeof extractNodes>[number]

export const useProjectFilter = (): InFilterDefinition<string> => {
  const source = useGraphqlDataSource(
    {
      paginationType: 'infinite-scroll',
      fetchPolicy: 'cache-first',
      document: ImputableProjectFilterDocument,
      perPage: 25,
      mapData: (data) => extractNodes(extractConnection(data)),
      mapPagination: (data) => {
        const connection = extractConnection(data)
        const pageInfo = connection.pageInfo

        return {
          total: connection.totalCount ?? 0,
          cursor: pageInfo.endCursor ?? '0',
          hasNextPage: !!pageInfo.hasNextPage,
        }
      },
      mapVariables: ({ search }) => ({
        nameOrCode: search,
      }),
    },
    []
  )

  return {
    label: i18n.t('expenses_v2.forms.fields.projects.project'),
    type: 'in' as const,
    options: {
      source,
      mapOptions: (project: Node) => ({
        label: project.code ? `${project.code} - ${project.name}` : project.name,
        value: project.id,
      }),
    },
  }
}
